import { ClampLines } from '@seek/discover-ui';
import { Text } from 'braid-design-system';

interface Props {
  salary?: string;
  currencyLabel?: string;
}

export const Salary = ({ salary, currencyLabel }: Props) => {
  if (!salary) {
    return null;
  }

  const salaryAndCurrencyDisplayLabel = currencyLabel
    ? `${salary} (${currencyLabel})`
    : salary;

  return (
    <Text>
      <ClampLines numLines="2" originalText={salaryAndCurrencyDisplayLabel}>
        {salaryAndCurrencyDisplayLabel}
      </ClampLines>
    </Text>
  );
};
